<template lang="html">
  <transition name="fade">
    <div v-if="isActive" class="modal" :class="{ 'is-active': isActive }">
      <div class="modal-background" @click="bgTap()"></div>

      <div class="modal-content" :style="safeAreaInsetStyle">
        <slot :params="params" :visible="isActive"> </slot>
      </div>

      <button
        v-if="showCloseButton"
        class="modal-close is-large"
        :style="safeAreaInsetStyle"
        aria-label="close"
        @click="$modal.hide(name)"
      ></button>
    </div>
  </transition>
</template>

<script>
// Import index so we can observe events.
import ModalPlugin from './index.js';
import safeArea from '@/components/mixins/safe-area';

export default {
  name: 'modal',
  mixins: [safeArea],
  props: {
    name: {
      type: String,
      required: true,
    },
    showCloseButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    dismissOnBgTap: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  // variables
  data() {
    return {
      safeAreaInsetProp: 'margin-top',
      safeAreaDefaultInsetValue: '0px',
      isActive: false,
      params: {},
    };
  },
  beforeMount() {
    ModalPlugin.event.$on('toggle', (name, visible, params) => {
      if (name === this.name) {
        // if (typeof state === 'undefined') {
        //   visible = !this.isActive;
        // }
        this.toggle(visible, params);
      } else if (name === '*') {
        this.toggle(visible.params);
      }
    });
  },
  methods: {
    bgTap() {
      if (this.dismissOnBgTap) {
        this.$modal.hide(this.name);
      }
    },
    toggle(visible, params = {}) {
      this.isActive = visible;
      this.params = params;
      this.$emit('modal-toggle', visible);
    },
  },
};
</script>

<style lang="stylus">
.modal {
  display: flex
}

.slide-up-enter-active, .slide-up-leave-active {
  transition: all 0.3s ease-out;
  transition-delay: 0.2s;
}

.slide-up-enter, .slide-up-leave {
  opacity: 0;
  transform: translateY(100px);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease-out;

  .modal-content {
    transition: all 0.2s ease-out;
  }
}

.fade-enter, .fade-leave, .fade-leave-to {
  opacity: 0;

  .modal-content {
    transform: scale(0.5);
    opacity: 0
  }
}
</style>
